import { Box } from "@material-ui/core";
import styled from "styled-components";


export const Tag = styled.div`
        font-size: 10px;
        color: ${props => props.color};
        border: 2px solid ${props => props.color};
        font-weight: 700;
        padding: 4px 10px;
        border-radius: 8px;
        text-align: center;
        cursor: default;
`